export default __webpack_public_path__ + "static/media/xbox.01581834.png";